/**
 * Album Service
 *
 * Exposes the app-wide {@link IAlbumService} instance — Supabase is the only
 * implementation (mock mode was removed app-wide).
 *
 * @module features/albums/services/albumService
 */

import type { IAlbumService } from './albumService.types';
import { SupabaseAlbumService } from './supabaseAlbumService';

export type { IAlbumService } from './albumService.types';

/**
 * Album service instance — Supabase-backed.
 */
export const albumService: IAlbumService = new SupabaseAlbumService();

/**
 * Export class for testing
 */
export { SupabaseAlbumService };
